<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" style='background-color:#fff'>
        <div class="row p-3">
          <div class="col-12">
            <div v-if="payTransactionId">Thank you for your interest. Please save this payment tranaction id for any future communication regarding your payment. Your payment transaction id is <h4 class="primary-color">{{ payTransactionId }}</h4></div><br>
            <h3 class="mb-0">
              <span class="pull-left">Complete Your Profile</span>
              <span class="pull-right pointer" @click="signOut"><i class="fa-solid fa-right-from-bracket"></i></span>
            </h3>
          </div>
          <ValidationObserver ref="quickProfileForm">
            <form class="mt-4">
              <div v-bind:class = "(operatingsystem == 'web') ? 'gide_scroll_box row m-0' : 'row m-0'">
                <div class="form-group col-12">
                  <label for="yourFullName">Your Email Address</label>
                  <ValidationProvider
                    name="Name"
                    rules="required|regex:^[a-zA-Z0-9 '.-]*$"
                    v-slot="{ errors }"
                  >
                    <input v-model="userData.user_email" type="text" class="form-control mb-0" disabled>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!-- Verify your Email Address -->
                <div class="form-group col-12" v-if="userData.user_email_verified != 1">
                  <label for="yourFullName">Verify your Email Address</label>
                  <ValidationObserver ref="userActivationForm">
                    <ValidationProvider name="Activation code" rules="required" v-slot="{ errors }">
                      <input v-model="userActivationCode" type="text" class="form-control mb-0" id="exampleInputPassword1" placeholder="Enter OTP Here">
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </ValidationObserver>
                  <div class="d-flex justify-content-between w-100 mt-2 mb-2">
                    <!-- <button :disabled="!showSubmitBtn" type="button" :data-sitekey="YOUR_SITE_KEY" data-callback='recaptchaOnClick' data-action='submit' id="g-recaptcha" class="g-recaptcha btn  btn-primary" @click="userActivate"> -->
                    <button class="btn  btn-primary" @click="userActivate()" v-if="resendEmailBtn">
                      Validate
                    </button>
                    <!-- <button :disabled="!showSubmitBtn" type="button" :data-sitekey="YOUR_SITE_KEY" data-callback='recaptchaOnClick' data-action='submit' id="g-recaptcha" class="g-recaptcha btn  btn-warning" @click="userActivationEmail()" v-if="resendEmailBtn"> -->
                    <button class="btn  btn-warning" @click="userActivationEmail()" v-if="resendEmailBtn">
                      Resend OTP
                    </button>
                  </div>
                  <span v-if="!resendEmailBtn">
                    <small>Kindly check your span folder for OTP/Password related emails. Also ensure that your mailbox is not full.<span class="primary-color">&nbsp;You can request for otp after 10 secs</span></small>
                  </span>
                  <span v-else>
                    <small>OTP will be sent to <span class="information-color">{{userData.user_email}}</span></small>
                  </span>
                </div>

                <!-- Verify your Mobile Number -->
                <div class="form-group col-12" v-if="userData.user_mobile_verified != 1">
                  <label for="yourFullName">Verify your mobile number</label>
                  <ValidationObserver ref="otpForm">
                    <form :key="updateKey">
                      <div class="form-group row w-100">
                        <div class="col-md-6 mb-3">
                          <label for="validation_country">Country</label>
                          <select v-model="vmUserFormData.user_country" :disabled="showModelAskOtpBox" class="form-control">
                            <template>
                              <option v-for="(country, index) of cvCountryOptions" :key="index+'1'" :value="country">
                                {{country.country_name}} (+ {{country.country_phone_code}})
                              </option>
                            </template>
                          </select>
                        </div>

                        <div class="col-md-6 mb-3">
                          <ValidationProvider name="Mobile Number" rules="required" v-slot="{ errors }">
                            <label for="otpno">Mobile number</label>
                            <input type="tel" minlength="3" maxlength="20" pattern="[0-9]" class="form-control" id="user_mobile" v-model="vmUserFormData.user_mobile" name="Mobile Number"/>
                            <span class="text-danger">{{ errors[0] }}</span>
                            <span class="clearSpanIcon" v-if="showModelAskOtpBox" @click="clear()"><i class="fa-solid fa-circle-xmark"></i></span>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="form-group" v-if="showModelAskOtpBox">
                        <label for="otpno">OTP</label>
                        <ValidationProvider name="Otp" rules="required|min:6|max:6" v-slot="{ errors }">
                          <input type="text" class="form-control" id="otp" v-model="vmOtpCode" name="OTP"/>
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <span class="primary-color"><small>* OTP shall be sent on SMS & Whatsapp</small></span>
                      </div>
                    </form>
                  </ValidationObserver>

                  <button class="btn  btn-warning pull-right" @click="resendOtp()" v-if="showModelAskOtpBox">
                    Resend OTP
                  </button>
                  <b-button v-if="showModelAskOtpBox" size="sm" variant="primary" @click="verifyOTP()" :disabled="!vmOtpCode || vmOtpCode && vmOtpCode.length!=6">
                    Verify
                  </b-button>
                  <b-button class="pull-right" v-else-if="!showModelAskOtpBox" size="sm" variant="warning" @click="sendOtp()">
                    Send OTP
                  </b-button>
                </div>

                <div class="form-group col-12">
                  <label for="yourFullName">Your full name</label>
                  <ValidationProvider
                    name="Name"
                    rules="required|regex:^[a-zA-Z0-9 '.-]*$"
                    v-slot="{ errors }"
                  >
                    <input v-if="!userData.login_type || userData.login_type == 'email'" v-model="userName" type="text" minlength="3" maxlength="20" class="form-control mb-0" style="color:var(--iq-dark)" placeholder="Your Full Name">
                    <input v-else v-model="userName" type="text" class="form-control mb-0" placeholder="Your Full Name" minlength="3" maxlength="20" disabled>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!-- Dont Show for Google & Apple Login -->
                <div class="form-group col-12" v-if="!userData.login_type || userData.login_type == 'email'">
                  <label for="exampleInputPassword1">Password</label>
                  <ValidationProvider name="Password" rules="required|min:6|max:16" v-slot="{ errors }">
                    <input v-model="userPassword" type="password" class="form-control mb-0" id="exampleInputPassword1" placeholder="Password">
                    <span class="text-danger">{{ errors[0] }}</span>
                    <small>Should be between 6 and 16 characters</small>
                  </ValidationProvider>
                </div>

                <!-- Hide this part as we are already activating mobile using OTP -->
                <div v-show="false" class="col-xs-12 col-sm-6 col-md-4 col-lg-6 mb-3">
                  <label for="validation_country">Country Code</label>
                    <div class="flex-row">
                      <ValidationProvider
                        name="select one"
                        rules="required"
                        v-slot="{ errors }">
                          <select v-model="countryCodes" class="form-control w-100" id="validation_country">
                          <template class="w-100">
                            <option class="w-100" v-for="(country, index) of cvCountryOptions" :key="index+'1'" :value="country">
                              {{country.country_name}} (+ {{country.country_phone_code}})
                            </option>
                          </template>
                        </select>
                        <span class="text-danger"> {{ errors[0] }} </span>
                      </ValidationProvider>
                    </div>
                </div>
                <div v-show="false" class="col-xs-12 col-sm-6 col-md-8 col-lg-6 mb-3">
                  <ValidationProvider
                    name="Enter contact number"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="validation_stu_contact_no">
                      Contact Number
                    </label>
                    <input v-model="userMobile" type="tel" minlength="3" maxlength="20" pattern="[0-9]" class="form-control" id="validation_stu_contact_no" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- Hide this part as we are already activating mobile using OTP -->

                <div class="form-group col-12 mt-2" v-if="(userData.user_role && userData.user_role == 'USERROLE11114')">
                  <div v-if="schoolId" class="col-12">Your current {{ cvSchoolLabel }} is<br><b>{{userProfile.org_name}}</b></div>
                  <div id="studentRole" class="form-group col-12">
                    <div class="form-group">
                      <label for="Choose Your School/College/University">Choose/Update Your {{cvSchoolLabel}}</label>
                      <multiselect
                          v-model="studentSchool"
                          :options="schoolOptionsWithAdd"
                          :placeholder="cvSelectBoxText + ' ' + cvSchoolLabel"
                          track-by="org_id"
                          ref="multiselectschool"
                          @search-change="SearchSchoolList($event)"
                          :custom-label="customSchoolLabel"
                          @input="selectSchool"
                        >
                        <span slot="noResult">
                          School not found<br><hr>
                          <span @click="showAddSchool()" class="schoolAdd" varient="primary">
                            Click here to add school
                          </span>
                        </span>
                      </multiselect>
                      <span><small><i class="fa-solid fa-circle-info primary-color"></i>&nbsp;Cannot select the same school</small></span><br>
                      <span><small><i class="fa-solid fa-circle-info primary-color"></i>&nbsp;School not found. <span @click="showAddSchool()" class="pointer primary-color">Click here to Add School</span></small></span>
                    </div>

                    <template v-if="addSchoolShow">
                      <ValidationObserver ref="schoolForm">
                        <div class="form-group row">
                          <div class="col-md-12 col-lg-12 col-sm-12" v-for="(item, index) in cvSchoolForm" :key="index">
                            <label :for="item.label">{{item.label}}</label>
                            <ValidationProvider :name="item.label" rules="required|min:2" v-slot="{ errors }">
                              <input v-model="schoolForm[item.key]" :type="item.type" class="form-control mb-0" :id="item.label">
                              <span class="text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                          </div>
                        </div>
                      </ValidationObserver>
                      <div class="form-group" style="margin-bottom:50px">
                        <button class="btn btn-primary" type="button" @click="addSchool" style="float: right;">
                          Add School
                        </button>
                        <b-button type="button" @click="addSchoolShow = false" style="float: right; margin-right:10px">
                          Cancel
                        </b-button>
                      </div>
                    </template>

                    <div class="form-group" v-show="false">
                      <label for="Class">{{cvBoardLabel}}</label>
                      <multiselect
                        v-model="studentBoard"
                        :options="cvBoardOptions"
                        :placeholder="cvSelectBoxText +' '+ cvBoardLabel"
                        label="board_name"
                        track-by="board_name">
                      </multiselect>
                      <div v-show="showErrBox2" class="text-danger">
                        {{errMsg}}
                      </div>
                    </div>

                    <div class="form-group" v-show="false">
                      <label for="Class">{{cvClassLabel}}</label>
                      <multiselect
                        v-model="studentClass"
                        :options="cvClassOptions"
                        :placeholder="cvSelectBoxText +' '+ cvClassLabel"
                        label="class_name"
                        track-by="class_name">
                      </multiselect>
                      <div v-show="showErrBox2" class="text-danger">
                        {{errMsg}}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-inline-block col-12 w-100">
                  <div class="custom-control custom-checkbox d-inline-block mt-2 pt-1">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="tnc">
                    <label class="custom-control-label" for="customCheck1">I have read and accept the <a href="/content/Tnc" target="_blank">Terms of Use</a>
                    </label>
                    <div v-show="showTncErrBox" class="text-danger">
                      {{errMsg}}
                    </div>
                  </div>
                </div><!-- d-inline-block w-100 -->
                <div class="gide_button_fix">
                  <div class="SubmitBtn col-12">
                    <button type="button" class="btn btn-primary float-right" @click="userProfileComplete">
                      Submit
                    </button>
                  </div>
                </div>
              </div><!-- gide_scroll_box -->
            </form>
            <!-- <div class="sign-info" style="margin-top: 16px;">
              <span class="dark-color d-inline-block line-height-2">Go back to <router-link :to="{ path: 'login'}">Sign In</router-link>
              </span>
              <ul class="iq-social-media mt-4">
                <li>
                  <a href="https://www.facebook.com/highschoolmomsgroup" target="_blank"><i class="ri-facebook-box-line"></i></a>
                </li>
                <li>
                  <a href="https://twitter.com/hsminace" target="_blank"><i class="ri-twitter-line"></i></a>
                </li>
                <li>
                  <a href="https://www.instagram.com/highschoolmoms" target="_blank"><i class="ri-instagram-line"></i></a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/highschoolmoms/" target="_blank"><i class="ri-linkedin-line"></i></a>
                </li>
              </ul>
            </div> -->
            <div class="staticContent">
              <a href="/content/Tnc" target="_blank">Terms and Conditions</a>  | <a href="/content/PrivacyPolicy" target="_blank">Privacy Policy</a>
            </div>
          </ValidationObserver>
          <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
            <div v-html="toastMsg">
            </div>
          </b-toast>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<style lang="scss" scoped>
  @import url("../assets/css/custom.css");
  @import url("../assets/css/PriceSlider.css");
  .staticContent {
    margin-top: 20px;
    text-align: center;
    display:inline-flex;
    width: 100%;
    a{
      width: 100%;
    }
  }
  .SubmitBtn {
    width: 100%;
    padding-top: 13px;
    text-align: center;
  }
  .schoolAdd {
    color: var(--iq-primary);
    i {
      margin-right: 8px;
    }
  }
  .sign-info{
    border: 0px;
    padding:0px;
    margin:30px 0px;
  }
  @media screen and (min-width:576px){
    .gide_scroll_box{
      overflow: auto;
      height: calc(100vh - 320px);
      max-height: 550px;
      .form-group{
        width: 100%;
      }
    }
    .gide_box{
      // overflow: auto;
      // height: calc(100vh - 320px);
      // max-height: 550px;
      .form-group{
        width: 100%;
      }
    }
  }
  .gide_button_fix{
    float: right;
    width: 100%;
  }
  .gide_scroll_box{
    .form-group{
      width: 100%;
    }
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { User } from "../FackApi/api/user.js"
import { Organisations } from "../FackApi/api/organisation.js"
import ApiResponse from "../Utils/apiResponse.js"
import Multiselect from "vue-multiselect"
import config from "../Utils/config.js"
import { Countries } from "../FackApi/api/country.js"
import { reCaptcha } from "../Utils/reCaptcha.js"

export default {
  name: "RegisterV1",
  components: {
    Multiselect
  },
  data: () => ({
    YOUR_SITE_KEY: process.env.VUE_APP_GOOGLE_RECAPTCHA3_KEY,
    showSubmitBtn: true, // Deliberately set to True to avoid dependency on captcha as this is an innternal page
    showToast: false,
    toastMsg: null,
    toastVariant: "default",
    toastTitle: "Registration Response",
    userEmail: "",
    userId: null,
    userActivationCode: "",
    operatingsystem: window.__DEVICE_OS__,
    resendEmailBtn: false,
    cvSelectBoxText: "Start typing ",
    cvSchoolLabel: "School",
    cvBoardLabel: "Board",
    cvClassLabel: "Class",
    errMsg: "",
    cvSchoolLocality: " School Locality/Area/Sector",
    showTncErrBox: false,
    showErrBox1: false,
    showErrBox2: false,
    cvShowStudentInput: false,
    studentSchool: null,
    cvSchoolOptions: [],
    studentBoard: "",
    studentClass: "",
    cvClassOptions: config.ClassList,
    cvBoardOptions: config.BoardObjList,
    cvUniversityOptions: [],
    educatorSchool: "",
    userName: "",
    countryCodes: null,
    cvCountryOptions: [],
    userMobile: "",
    userRole: { user_role_id: "USERROLE11114" },
    userPassword: "",
    source: "",
    tnc: false,
    showPasswordField: false,
    cvUserRoleLabel: "You are a",
    device: "web",
    schoolForm: {
      org_name: "",
      org_locality: "",
      org_desc: "",
      org_board_offered: "",
      org_city: "",
      org_state: "",
      org_country: "",
      org_address: "",
      org_contact: "",
      org_website: ""
    },
    cvSchoolForm: [
      { key: "org_name", type: "text", label: "School Name" },
      { key: "org_locality", type: "text", label: "School Locality" },
      { key: "org_city", type: "text", label: "School City" },
      { key: "org_country", type: "text", label: "School Country" }
    ],
    addSchoolShow: false,
    disableUserRole: false,
    schLimit: 20,
    cvSchoolOptionsBackup: [],
    orgData: {
      id: 54238,
      org_id: "GIDE_ORG_1",
      user_id: "1",
      acc_id: "1",
      org_name: "GIDE.AI",
      type: "ORG",
      org_desc: `<h1><strong style="color: rgb(226, 38, 44);">GIDE.AI</strong><strong>: </strong>Your Gateway to Scholarships and Career Success</h1><p><strong style="color: rgb(230, 0, 0);">Brought to you by Asia's largest Student and Parent community - High School Moms (HSM)</strong></p><p>Access futuristic career assessment, profile building, test preparation, great scholarships, and career guidance all in one integrated experience.</p><p><br></p>`,
      org_website_email: null,
      org_admin_email: "admin@gide.ai",
      org_admision_email: "admissions@gide.ai",
      org_admission_requirement: null,
      org_top_alums: null,
      org_major_industries_around: null,
      org_clubs: null,
      org_college_type: null,
      org_city: null,
      org_country: null,
      org_founding_year: null,
      org_application_deadline: null,
      org_intake_count: null,
      org_intake_type: null,
      org_currency: null,
      org_avg_tuition_min: null,
      org_avg_tuition_max: null,
      org_scholarship_min: null,
      org_scholarship_max: null,
      org_tnc: 0,
      created_on: "2023-11-22T23:26:47.000Z",
      deleted: 0,
      country_id: null,
      org_profile_img: "https://web.gide.ai/img/GideWhiteNRed.2533ee45.jpeg",
      org_cover_img: "https://gide-assets.s3.amazonaws.com/GIDECover.White.png",
      org_state: null,
      org_uid: "",
      org_domain: "web.gide.ai",
      org_domain_is_validated: 99,
      country_name: null,
      currency_name: null,
      currency_code: null
    },
    schoolCheckRegx: / school|college|institute|academy|mandir|high|centre|Vidyapeeth|convent|vihar|house|vidhyapit|devshala|niketan|vidhyapith|Vidyapith|institution|Shiksha|bhavan|society|secondary|Vidhyalaya|peeth|guru|dps|Secondary|kendra|kendriya|senior|ashram|campus|sch|public|pub|the|Vidyalaya|sansthan/gmi,
    propOpenedInModal: false,

    // OTP
    cvOTP: "Enter the otp",
    cvOtpDesc: "OTP has been send to your mobile no.",
    cvOtpLAbel: "OTP",
    vmOtpCode: "",
    vmUserFormData: {},
    showModal: false,
    showModelAskOtpBox: false,
    cvUserCountryLabel: "Country",
    cvSelectLabel: "Select ",
    value: null,
    showMobileOtpModal: false,
    updateKey: 1,
    payTransactionId: null,
    // OTP
    schoolId: null,
    isLoggingOut: false,
    userProfile: null
  }),
  props: {
    propShowNavBar: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    sourceData () {
      return this.$store.getters["SourceTracker/getUserSource"]
    },
    saasOrgData () {
      return this.$store.getters["SaasOrgData/getSaasOrgData"]
    },
    schoolOptionsWithAdd () {
      return [
        {
          org_id: "__add_new__",
          name: "Click here to add school"
        },
        ...this.cvSchoolOptions
      ]
    }
  },
  beforeMount () {
    if (this.userData) {
      this.userEmail = this.userData.user_email
      this.userName = this.userData.user_name
      this.show_user_email = true
    }
    else {
      this.$router.push("/login")
    }
  },
  async mounted () {
    if (this.$route.query.pay_tid) {
      this.payTransactionId = this.$route.query.pay_tid
    }
    this.vmUserFormData.user_mobile = this.userData.user_mobile ? this.userData.user_mobile : ""

    if (this.vmUserFormData.user_mobile.length > 10 && (this.vmUserFormData.user_mobile.slice(0, 2) === "91")) {
      this.vmUserFormData.user_mobile = this.vmUserFormData.user_mobile.substring(2)
    }

    if (this.propOpenModal) {
      this.showModal = true
    }
    await this.getOrgDetails()
    this.showResendEmail()

    if (this.$route.query.code) {
      let code = JSON.parse(atob(this.$route.query.code))
      this.userEmail = code.user_email
      this.userId = code.user_id = 0 || code.user_id == "0" ? null : code.user_id
      this.userActivationCode = code.otp
    }
    else if (this.userData) {
      this.userEmail = this.userData.user_email
      this.show_user_email = true
    }
    else {
      this.$router.push("/login")
    }

    /*
    let context = this
    if (window.grecaptcha) {
      // Recaptcha Already verified
      this.showSubmitBtn = true
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha.render("g-recaptcha", {
        sitekey: this.YOUR_SITE_KEY,
        size: "invisible", // 'compact' or 'invisible' are also available
        callback: context.recaptchaOnClick // This function is called on Submiting the form.
      })
    })
    */

    await this.getOrgDetails()
    history.pushState(null, null, location.href)
    window.onpopstate = function () {
      history.go(1)
    }

    // if sourceData is available then store in source else take user defined value to store in source
    if (this.sourceData) {
      this.source = this.sourceData
    }

    this.loadRequiredData()
    this.autoPopulateQuickProfile()
  },
  methods: {
    /**
     * autoPopulateQuickProfile
     */
    async autoPopulateQuickProfile () {
      try {
        if (!this.userProfile) {
          this.userProfile = await User.userProfileView(this, this.userData.user_id)
          console.log(this.userProfile.resp_data.data.org_id, this.cvSchoolOptions, "XXXX userProfile ", this.userProfile)
          if (this.userProfile.resp_status) {
            this.userProfile = this.userProfile.resp_data.data
          }
        }

        // set the school name
        this.schoolId = this.userProfile.org_id
        let school = this.cvSchoolOptions.find(e => e.org_id == this.userProfile.org_id)
        if (school) {
          this.studentSchool = school
        }

        // set the class
        if (this.userProfile.class_name) {
          this.studentClass = { class_name: this.userProfile.class_name }
        }

        // set the board name
        if (this.userProfile.board_name) {
          this.studentBoard = { board_name: this.userProfile.board_name }
        }
      }
      catch (err) {
        console.error("Exception in autoPopulateQuickProfile() and err: ", err.message)
      }
    },
    // OTP
    /**
     * close
     */
    close () {
      this.showModelAskOtpBox = false
      this.$emit("emitCloseOtpModal", true)
    },
    /**
     * clear
     */
    clear () {
      this.vmUserFormData.user_mobile = null
      this.vmOtpCode = null
      this.showModelAskOtpBox = false
    },
    /**
     * resendOtp
     */
    async resendOtp () {
      let data = {
        user_id: this.userData.user_id,
        user_mobile: `+${this.vmUserFormData.user_country.country_phone_code}` + this.vmUserFormData.user_mobile
      }
      let profileEditResp = await User.ReSendOtp(this, data)
      await ApiResponse.responseMessageDisplay(this, profileEditResp)
    },
    /**
     * SendOtp
    */
    async sendOtp () {
      try {
        if (this.vmUserFormData.user_mobile && this.vmUserFormData.user_mobile.toString().length > 6) {
          let updateUserData = { ...this.userData }
          let data = {
            user_id: updateUserData.user_id,
            user_mobile: `+${this.vmUserFormData.user_country.country_phone_code}` + this.vmUserFormData.user_mobile
          }

          if (updateUserData.user_mobile && !updateUserData.user_mobile.includes("+")) {
            // If mobile number is without country code then add selected country code
            updateUserData.user_mobile = `+${this.vmUserFormData.user_country.country_phone_code}` + updateUserData.user_mobile
          }

          if (data.user_mobile === updateUserData.user_mobile && updateUserData.user_mobile_verified && Number(updateUserData.user_mobile_verified) === 1) {
            this.toastMsg = "Mobile number is already verified."
            this.showToast = true
            this.toastVariant = "danger"
            await this.$store.commit("User/setUserProfile", updateUserData)
            this.$emit("emitCloseOtpModal", true)
            return
          }

          let profileEditResp = await User.SendOtp(this, data)
          if (profileEditResp.resp_status) {
            this.showModelAskOtpBox = true
          }
          await ApiResponse.responseMessageDisplay(this, profileEditResp)
        }
        else {
          this.toastMsg = "Mobile number is not valid."
          this.showToast = true
          this.toastVariant = "danger"
        }
      }
      catch (error) {
        console.error("Exception in sendOtp and err: ".error.message)
      }
    },
    /**
     * otp verification
     */
    async verifyOTP () {
      try {
        let data = {
          user_id: this.userData.user_id,
          otp_code: this.vmOtpCode,
          user_country: this.vmUserFormData.user_country.id,
          user_mobile: this.vmUserFormData.user_mobile
        }

        let otpResp = await User.Verify_OTP(this, data)
        ApiResponse.responseMessageDisplay(this, otpResp)
        /* Verified if there is no err**/
        if (!otpResp.resp_status) {
          return false
        }

        let updatedUserData = { ...this.userData }
        updatedUserData.user_mobile = this.vmUserFormData.user_mobile
        updatedUserData.user_country = data.user_country
        updatedUserData.country_name = this.vmUserFormData.user_country.country_name
        updatedUserData.country_id = data.user_country
        updatedUserData.user_is_logged_in = 1
        updatedUserData.user_verification_internal = 1
        updatedUserData.user_mobile_verified = 1

        await this.$store.commit("User/setUserProfile", updatedUserData)
        this.showModelAskOtpBox = false
        this.$emit("emitCloseOtpModal", true)
      }
      catch (err) {
        console.error("Exception occurred at verifyOTP() and Exception:", err.message)
      }
    },
    // OTP
    // Code from QuickProfile
    /**
     * Validate Captcha and enable SignIn Button
     */
    async recaptchaOnClick (captchaToken) {
      // Handle the response from the reCAPTCHA server
      // Can be verified from the server side via Custome API
      await reCaptcha.createAssessment(this, this.YOUR_SITE_KEY, captchaToken)
      this.showSubmitBtn = true
    },
    /**
    /**
     * showResendEmail
     */
    showResendEmail () {
      setTimeout(() => {
        this.resendEmailBtn = true
      }, 10000)
    },
    /**
     * userActivationEmail
     */
    async userActivationEmail () {
      await User.userActivationEmail(this, this.userEmail)
      this.toastMsg = "Email Resent"
      this.showToast = true
      this.toastVariant = "success"
      this.resendEmailBtn = false
      this.showResendEmail()
    },
    /**
     * userActivate
     */
    async userActivate () {
      let valid = await this.$refs.userActivationForm.validate()
      if (!valid) {
        return
      }

      let userObj = {
        "user_email": this.userEmail,
        "user_id": this.userData && this.userData.user_id ? this.userData.user_id : this.userId,
        "activation_code": this.userActivationCode
      }
      let userActivateResp = await User.userActivate(this, userObj)
      await ApiResponse.responseMessageDisplay(this, userActivateResp)
      if (userActivateResp.resp_status) {
        userActivateResp.resp_data.data.user_is_logged_in = 1
        userActivateResp.resp_data.data.user_verification_internal = 1
        await this.$store.dispatch("User/setUserProfileAction", userActivateResp.resp_data.data)
      }
    },
    /**
     * getOrgDetails
     */
    async getOrgDetails () {
      try {
        // Do not get the org_details if running on localhost, for localdns we have to set the org_domain in DB
        if (process.env.VUE_APP_ENV == "local") {
          this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)
          return
        }

        const orgDomain = window.location.hostname
        if (this.saasOrgData) {
          // Found in Cache
          this.orgData = this.saasOrgData
        }
        else {
          const orgDetails = await Organisations.organisationView(this, this.orgId, orgDomain)
          if (!orgDetails.resp_status) {
            // set the details of GIDE_ORG_1 as default
            this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)
            return
          }

          this.orgData = orgDetails.resp_data.data
          // set the org data in local storage for saving in user table
          this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)

          // set the source for the user
          let source = this.orgData.org_uid
          if (this.sourceData) {
            source = this.orgData.org_uid + "_" + this.sourceData
          }

          this.$store.dispatch("SourceTracker/setCodeAction", source)
        }
      }
      catch (err) {
        console.error("Exception in getOrgDetails and err: ", err)
      }
    },
    /**
     * customSchoolLabel
     */
    customSchoolLabel (option) {
      if (option.org_id === "__add_new__") {
        return "Click here to add school"
      }
      return this.schNameWithCityCountry(option)
    },
    /**
     * getOrgDetails
    */
    selectSchool (selected) {
      if (selected && selected.org_id === "__add_new__") {
        this.showAddSchool()
        this.studentSchool = null
      }
    },
    /*eslint-disable */
    /**
     * getOrgDetails
     */
    async getOrgDetails () {
      try {
        // Do not get the org_details if running on localhost, for localdns we have to set the org_domain in DB
        if (process.env.VUE_APP_ENV == "local") {
          this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)
          return
        }

        const orgDomain = window.location.hostname
        if (this.saasOrgData) {
          // Found in Cache
          this.orgData = this.saasOrgData
        }
        else {
          const orgDetails = await Organisations.organisationView(this, this.orgId, orgDomain)
          if (!orgDetails.resp_status) {
            // set the details of GIDE_ORG_1 as default
            this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)
            return
          }

          this.orgData = orgDetails.resp_data.data
          // set the org data in local storage for saving in user table
          this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)

          // set the source for the user
          let source = this.orgData.org_uid
          if (this.sourceData) {
            source = this.orgData.org_uid + "_" + this.sourceData
          }

          this.$store.dispatch("SourceTracker/setCodeAction", source)
        }
      }
      catch (err) {
        console.error("Exception in getOrgDetails and err: ", err)
      }
    },
    /**
     * sch Name With City Country
     */
    schNameWithCityCountry ({ org_name, org_city, org_country }) {
      return `${org_name}${org_city ? ', '+org_city : ''}${org_country ? ', '+org_country : ''}`
    },
    /**
     * showAddSchool
     */
    showAddSchool () {
      this.addSchoolShow = true
      // this.$refs.multiselectschool.toggle()
    },
    /**
     * loadRequiredData
     */
    loadRequiredData () {
      this.countryDistinctList()
      this.schoolList()
    },
    /**
     * schoolList
     */
    async schoolList () {
      const filter = {
        limit: this.schLimit,
        type: ["SCH"]
      }

      let schoolResp = await Organisations.organisationList(this, filter, 1)
      if (schoolResp.resp_status) {
        this.cvSchoolOptions = Object.keys(schoolResp.resp_data.data).map((key)=> schoolResp.resp_data.data[key])
        this.cvSchoolOptionsBackup = [ ...this.cvSchoolOptions ]
      }
    },
    /**
     * SearchSchoolList
     */
    async SearchSchoolList (searchString) {
      if (!searchString || searchString.trim().length < 1) {
        this.cvSchoolOptions = [ ...this.cvSchoolOptionsBackup ]
        return
      }

      if (searchString.length < 3) {
        return
      }

      if (searchString.toLowerCase() === 'school' || searchString.toLowerCase() === 'schoo' || searchString.toLowerCase() === 'schoo' || searchString.toLowerCase() === 'sch') {
        this.toastMsg = 'Please enter your school name.'
        this.toastVariant = 'danger'
        this.showToast = true
        return
      }

      const filter = {
        type: ["SCH"],
        search: searchString.trim()
      }

      let schoolResp = await Organisations.organisationListSearch(this, filter)
      if (schoolResp.resp_status) {
        this.cvSchoolOptions = schoolResp.resp_data.data
        this.autoPopulateQuickProfile() // Update the options
      }
    },
    /**
     * universityList
     */
    async universityList (searchString = null) {
      let filter = {}

      if (searchString && searchString.trim().length >= 2) {
        filter.search = searchString.trim()
      }

      filter.limit = 24
      filter.type = ["SCH"] // Get Only Schools
      filter.fields = [ "org_name", "org_city", "org_country", "org_admin_email" ]

      let universityResp = await Organisations.organisationListSearch(this, filter)
      if (universityResp.resp_status) {
        this.cvUniversityOptions = Object.values(universityResp.resp_data.data)
      }
    },
    /**
    /**
     * userProfileComplete
     */
    async userProfileComplete () {
      let valid = await this.$refs.quickProfileForm.validate()
      if (!valid) {
        return
      }

      let validRoleInput = this.validateRoleInput()
      if (!validRoleInput) {
        return
      }

      if (!this.tnc) {
        this.errMsg = 'Tnc is required'
        this.showTncErrBox = true
        return false
      }

      let userObj = {
        'user_id': this.userData.user_id,
        'user_email': this.userData.user_email,
        'user_mobile': `+${this.countryCodes.country_phone_code}` + this.userMobile,
        'user_mobile_country_code': `+${this.countryCodes.country_phone_code}`,
        'user_name': this.userName,
        'user_password': this.userPassword ? this.userPassword : false,
        'user_first_time_login': this.userData.user_first_time_login,
        'user_role': this.userData.user_role ? this.userData.user_role : this.userRole.user_role_id, // If role has already been allocated during the manage/invite user by the admin of the org then use that
        'student_school': this.studentSchool ? this.studentSchool.org_id : (this.schoolId ? this.schoolId : "GIDE_ORG_1"),
        'student_school_name': this.studentSchool ? this.studentSchool.org_name : false,
        'user_city': this.studentSchool ? this.studentSchool.org_city : false,
        'user_country': this.countryCodes.id, // //country id in the country table
        'user_country_name': this.studentSchool ? this.studentSchool.org_city : false,
        'student_board': this.studentBoard ? this.studentBoard.board_name : false,
        'student_class': this.studentClass ? this.studentClass.class_name : false,
        'tnc': this.tnc,
        'module_obj_id': null,
        'module_type': null,
        'params': null,
        'device_id': window.__DEVICE_OS__,
        'fcm_push_token': "GIDE0000",
        'source' : this.source
      }

      if (this.userData.org_id) {
        userObj.org_id = this.userData.org_id
      }

      if (userObj.user_role === 'USERROLE11114') {
        if(!userObj.student_school && !this.schoolId) {
          // looks like student has not set the school info
          this.errMsg = 'School Info Missing'
          this.showErrBox1 = true
          console.error("ZZZZZZZ3", this.errMsg)
          return false
        }

        //student
        const params = {
          org_id: userObj.student_school,
          board_name: userObj.student_board,
          class_name: userObj.student_class
        }

        userObj.module_obj_id = params.org_id
        userObj.module_type = "SCH"
        userObj.params = JSON.stringify(params)
      }

      let userProfileCompleteResp = await User.userProfileComplete(this, userObj)
      await ApiResponse.responseMessageDisplay(this, userProfileCompleteResp)
      if (!userProfileCompleteResp.resp_status) {
        this.toastVariant = 'danger'
      }
      else {
        /* check if the user is logging in for the first time, if yes and
           the user_role is USERROLE11116(org_admin) take him to the organisation edit page
        */

        if (this.userData.user_first_time_login == 1 && this.userData.user_role == "USERROLE11116") {
          let org = Object.keys(userProfileCompleteResp.resp_data.roles)[0]
          org = userProfileCompleteResp.resp_data.roles[org]

          if (org.udr_name == "Owner") {
            // set the deeplink to the edit page only if the user is owner of the org
            const deepLink = `/org_edit/ORG/${org.module_obj_id}`
            await this.$store.dispatch("DeepLink/setDeepLinkAction", deepLink)
          }
        }

        if (userProfileCompleteResp.resp_data && userProfileCompleteResp.resp_data) {
          let userProfileData = userProfileCompleteResp.resp_data
          userProfileData.user_mobile_verified = 1
          userProfileData.user_email_verified = 1
          await this.$store.dispatch('User/setUserProfileAction', userProfileData)
          /**
           * DeepLink logic
           */
          let deepLink = this.$store.getters["DeepLink/getDeepLink"]
          if (deepLink) {
            this.$store.commit("DeepLink/deleteDeepLink", null)
            this.$router.push(deepLink)
          }
          this.$emit("emitCloseQuickProfileV1Internal")
        }
      }
    },
    /**
     * validateRoleInput
     */
    validateRoleInput () {
      if (this.userData.user_role && this.userData.user_role != "USERROLE11114") {
        // It looks like the user exists and has already been assigned a role. Most probably via the manage/Invite User Section in the organisation
        // To be checked only for UNIV, ORG roles not for student or parent
        return true
      }

      if (this.userRole.user_role_id === 'USERROLE11114') {
        if (!this.studentSchool && !this.schoolId) {
          this.errMsg = 'Please select a school'
          this.showErrBox1 = true
          console.error("ZZZZZZZ1", this.errMsg)
          return false
        }
        else if (!this.studentClass) {
          this.errMsg = 'Please select a Class'
          this.showErrBox2 = true
          console.error("ZZZZZZZ2", this.errMsg)
          return false
        }
      }

      return true
    },
    /**
     * addSchool
    */
    async addSchool () {
      let valid = await this.$refs.schoolForm.validate()
      if (!valid) {
        return
      }

      if (!this.schoolForm.org_name.match(this.schoolCheckRegx)) {
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "Please enter valid school name"
        return
      }

      this.schoolForm.type = "SCH"
      this.schoolForm.org_admin_email = process.env.VUE_APP_SUPPORT_EMAIL
      this.schoolForm.deleted = 3
      this.schoolForm.user_role = "USERROLE11114" // user is creating the organisation
      this.schoolForm.org_name += ", " + this.schoolForm.org_locality

      const schoolAddResp = await Organisations.organisationAdd(this, this.schoolForm);
      if (schoolAddResp.resp_status) {
        this.cvSchoolOptions.unshift(schoolAddResp.resp_data)
        this.studentSchool = schoolAddResp.resp_data
        this.addSchoolShow = false
      }

      ApiResponse.responseMessageDisplay(this, schoolAddResp, "Add School")
    },
    /**
     * countryDistinctList
     */
    async countryDistinctList () {
      try {
        let matchWithQuery = "distinct country"
        let countryDistinctListResp = await Countries.countryList(this, matchWithQuery)
        if (countryDistinctListResp && !countryDistinctListResp.resp_status) {
          return false
        }

        this.cvCountryOptions = countryDistinctListResp.resp_data.data
        if (this.userData && this.userData.country_id) {
          const findIndex = this.cvCountryOptions.findIndex(ele => ele.id === this.userData.country_id)
          if (findIndex >= 0) {
            this.countryCodes = this.cvCountryOptions[findIndex]
            if (this.userData.user_mobile) {
              let regx = new RegExp(this.countryCodes.country_phone_code, 'gm')
              this.userMobile = this.userData.user_mobile.replace(regx, '')
            }
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at countryDistinctList() and Exception:", err.message)
      }
    },
    /**
     * signOut
     */
    async signOut () {
      try {
        this.isLoggingOut = true
        if (window.location.hostname.toLowerCase().includes("gide.ai") ||
          (process.env.VUE_APP_ENV != "prod" && process.env.VUE_APP_ENV != "uat")
        ) {
          await this.$gAuth.signOut()
        }
        await this.$store.commit("User/setUserLogout")
      }
      catch (err) {
        console.error("Exception occurred at signout() and Exception:", err.message)
      }

      setTimeout(async () => {
        await this.$router.push("/login")
        this.isLoggingOut = false
        window.location.reload()
      }, 200)
    }
  }
}
</script>

